import { getRuntimeConfig } from "src/getRuntimeConfig";

// INTERCOM
export const INTERCOM_APP_ID = getRuntimeConfig().CNB_ENV === "dev" ? "ld516kif" : "y12kdvhe";

// APP TEXT
export const APP_TITLE = "[ALPHA] - ZURICH";
export const FOOTER_TEXT = `${new Date().getFullYear()} CNB DEV TEAM ♡ `;

// PAGES TITLE
export const PAGE_TITLE_HOME = "Home";
export const PAGE_TITLE_DASHBOARD = "Portfolio";

// UI CONSTANTS
export const FOOTER_HEIGHT = 30;
export const HEADER_HEIGHT = 60;
export const DRAWER_WIDTH = "220px";

//COUNTRY CODES
export const COUNTRY_CODES = [
  "AUD",
  "CAD",
  "CHF",
  "DKK",
  "EUR",
  "GBP",
  "HKD",
  "INR",
  "JPY",
  "NOK",
  "NZD",
  "PHP",
  "SGD",
  "USD",
];

// FIAT CURRENCIES C&B OFFERS
export const FIAT_CURRENCIES = [
  {
    code: "AUD",
    name: "Australian Dollar",
  },
  {
    code: "CAD",
    name: "Canadian Dollar",
  },
  {
    code: "EUR",
    name: "Euro",
  },
  {
    code: "GBP",
    name: "British Pound",
  },
  {
    code: "NZD",
    name: "New Zealand Dollar",
  },
  {
    code: "USD",
    name: "US Dollar",
  },
];

// These denominations allow the wallets page to be visualised with a crypto quote currency
export const CRYPTO_DENOMINATIONS = [
  {
    code: "BTC",
    logoUrl: "https://cdn.calebandbrown.com/bitcoin",
    name: "Bitcoin",
  },
];

export const CRYPTO_DENOMINATION_CODES = CRYPTO_DENOMINATIONS.map((x) => x.code);

export const TOKENS_WITHOUT_ICONS = ["ALICE", "BAYC", "TONE"];

export const defaultTag = "| Caleb & Brown";

/*
  If you add more pages that you want a custom title, add to the seoConstants objects.
  Make sure the the 'pageName' key is the same as the url e.g. /wallets => key should be wallets
*/
export const seoConstants: {
  [pageName: string]: { title: string };
} = {
  login: {
    title: "Login",
  },
  "secure-file-upload": {
    title: "Secure File Upload",
  },
  "secure-biometrics": {
    title: "Secure Biometrics",
  },
  "uk-assessment": {
    title: "UK Appropriateness Assessment",
  },
  dca: {
    title: "DCA",
  },
  "reset/request": {
    title: "Reset",
  },
  "password/reset": {
    title: "Reset",
  },
  // Without an entry here DynamicHelmet keeps its initial "login" state, so the
  // manual Travel Rule thank-you tab would be titled "Login".
  "travel-rule/done": {
    title: "Travel Rule",
  },
  // Adhoc Re-KYC (AU/NZ) magic-link page — same DynamicHelmet trap as above.
  adhocKyc: {
    title: "Identity Re-verification",
  },
  signup: {
    title: "Signup",
  },
  portfolio: {
    title: "Portfolio",
  },
  wallets: {
    title: "Holdings",
  },
  trade: {
    title: "Swap",
  },
  research: {
    title: "Research",
  },
  fund: {
    title: "Fund",
  },
  "wallets/deposit": {
    title: "Deposit",
  },
  "wallets/addresses": {
    title: "Addresses",
  },
  transactions: {
    title: "History",
  },
  "transactions/overview": {
    title: "History",
  },
  markets: {
    title: "Markets",
  },
  "refer-a-friend": {
    title: "Refer A Friend",
  },
  targets: {
    title: "Target Orders",
  },
  sectors: {
    title: "Market: Sectors",
  },
  profile: {
    title: "Profile",
  },
  "banking/details": {
    title: "Banking Details",
  },
  "admin/announcements": {
    title: "Announcements",
  },
  "admin/accounts": {
    title: "Accounts",
  },
};

export const INACTIVE_TOKEN_MESSAGE =
  " This token has been marked as inactive. This could be related to a token migration. For more information please contact us at support@calebandbrown.com";

export const HOLDINGS_CHART_COLORS = ["#005790", "#FC4C4C", "#CCC3AE", "#0BEC9F"];

export const supportLink =
  "https://support.calebandbrown.com/en/collections/3258001-caleb-brown-portal";
